import type { Action } from './actions'
import type {
    CategoryShortDTO,
    CategoryWithProductsDTO,
    MetaShortDTO
} from 'shared/types/api'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    +metaData: ?MetaShortDTO,
    +categories: ?Array<CategoryShortDTO>,
    +categoryWithProducts: ?CategoryWithProductsDTO,
    +selectedAllergens: ?Array<string>,
    dataLoaded: ?boolean,
    +error?: any,
    +networkError?: any
}

const initialState: State = {
    metaData: null,
    categories: [],
    selectedAllergens: [],
    categoryWithProducts: null,
    dataLoaded: false
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_CATALOG_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'CATEGORY_WITH_PRODUCTS_RESULTS':
            return {
                ...state,
                categoryWithProducts: action.data
            }
        case 'CATEGORY_WITH_PRODUCTS_RESET':
            return {
                ...state,
                categoryWithProducts: null
            }
        case 'SELECTED_ALLERGENS':
            return {
                ...state,
                selectedAllergens: action.data.selectedAllergens
            }
        case 'CATALOG_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.catalog)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
